// USAGE: <img src="" class="lazy-extended" data-original="path-to-img.jpg" />
const lazyLoadCallback = (entries) => {
	for (let i = 0; i < entries.length; i++) {
		let thisEntry = entries[i];
		if (thisEntry.isIntersecting) {
			$(thisEntry.target).data('alreadyLoaded', true);
			$(thisEntry.target).on('load', function () {
				$(this).addClass('already-loaded');
			});
			$(thisEntry.target).attr('src', $(thisEntry.target).data('original'));
			theObserver.unobserve(thisEntry.target);
		}
	}
};

const observerSettings = {
	rootMargin: '50px 0px 0px 0px',
	threshold: 0.1,
};

let theObserver = false;
export const lazyLoadImage = () => {
	if (document.querySelector('#wishlistDisplay') !== null) {
		const wishListImageInterval = setInterval(function () {
			if (document.querySelectorAll('#wishlistDisplay img.lazy-extended').length > 0) {
				observerSetup();
				clearInterval(wishListImageInterval);
			}
		}, 500);
		setTimeout(function () {
			clearInterval(wishListImageInterval);
		}, 5000);
	} else {
		observerSetup();
	}
};

const observerSetup = () => {
	const lazyImages = document.querySelectorAll('img.lazy-extended');
	if (window.IntersectionObserver) {
		if (theObserver) {
			theObserver.disconnect();
		}
		theObserver = new IntersectionObserver(lazyLoadCallback, observerSettings);
		for (let i = 0; i < lazyImages.length; i++) {
			let thisImage = lazyImages[i];
			if (!thisImage.classList.contains('alreadyLoaded')) {
				theObserver.observe(thisImage);
			}
		}
	} else {
		for (let i = 0; i < lazyImages.length; i++) {
			let thisImage = lazyImages[i];
			thisImage.src = thisImage.dataset.original;
			thisImage.classList.add('already-loaded');
		}
	}
};
